import { QueryKeys } from "@/constants/query-keys";
import { OnboardingWeightStep } from "@/features/onboarding/components/onboarding-weight-step";
import { useGetBodyStats } from "@/hooks/requests/body-status/use-get-body-stats";
import { useUpdateBodyStats } from "@/hooks/requests/body-status/use-update-body-stats";
import { useToast } from "@/hooks/ui/use-toast";
import { useStepRouteInfo } from "@/hooks/use-step-route-info";
import { useQueryClient } from "@tanstack/react-query";

const DEFAULT_CM = 170;

const StartingFromPage = () => {
  const { navigateToNextStep, preloadNextRoute } = useStepRouteInfo();
  const { bodyStats } = useGetBodyStats();
  const { updateBodyStatsAsync, isUpdating } = useUpdateBodyStats();
  const queryClient = useQueryClient();
  const { showError } = useToast();

  const handleSubmit = async (kg: number) => {
    try {
      await Promise.all([
        preloadNextRoute(),
        updateBodyStatsAsync({
          height: Number(bodyStats?.height) || DEFAULT_CM,
          heightUnit: "cm",
          startingWeight: kg,
          startingWeightUnit: "kg",
          currentWeight: kg,
          currentWeightUnit: "kg",
          // Preserved here; the next step ("Getting To") captures the real target.
          targetWeight: Number(bodyStats?.targetWeight) || kg,
          targetWeightUnit: "kg",
        }),
      ]);
      await queryClient.invalidateQueries({ queryKey: [QueryKeys.BODY_STATS] });
      navigateToNextStep();
    } catch (error) {
      showError(error instanceof Error ? error.message : "An unexpected error occurred");
    }
  };

  return (
    <OnboardingWeightStep
      title={
        <>
          Where are we
          <br />
          starting from?
        </>
      }
      subtitle="Your current weight"
      isSubmitting={isUpdating}
      onSubmit={handleSubmit}
    />
  );
};

export default StartingFromPage;
